export default __webpack_public_path__ + "static/media/drop.20c5227d.svg";